import { keepPreviousData, useQuery } from '@tanstack/react-query';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';
import {
	getMipKycSetting,
	getKycWorkflowKycSetting,
} from '@dealstack/frontend/shared/dataExchange/services/kyc-setting.service.ts';

export const useMipKycSetting = (mipId: string) => {
	return useQuery({
		queryKey: [API_PATHS.KYC_SETTING_MIP_GET, mipId],
		queryFn: () => getMipKycSetting(),
		enabled: !!mipId,
		placeholderData: keepPreviousData,
		select: (data) => data.payload,
	});
};

export const useKycWorkflowKycSetting = (kycWorkflowId: string) => {
	return useQuery({
		queryKey: [API_PATHS.KYC_SETTING_KYCWORKFLOW_KYCWORKFLOWID_GET, kycWorkflowId],
		queryFn: () => getKycWorkflowKycSetting(kycWorkflowId),
		enabled: !!kycWorkflowId,
		placeholderData: keepPreviousData,
		select: (data) => data.payload,
	});
};
